<template>

  <div
    class="feed-content"
    :class="{'box-loading': loading}">
    <div
      class="photo"
      v-if="!edit && activity.author_user">
      <Avatar
        :src="imgSrc"
        :name="activity.author_user.name"
        size="40px"
        radius="20px"
        resize="100x100x1" />
    </div>
    
    <div
      class="content"
      v-if="!edit">
      
      <div
        v-if="permissions.includes('manage_candidates')"
        class="feed-actions dropdown">
        <button
          class="btn btn-sm btn-light"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-chevron-down" />
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            class="dropdown-item"
            @click="editEvaluation(activity.evaluation)">
              <i class="fas fa-pencil-alt" /> {{ $t('Edit') }}
            </button>
          <button
            class="dropdown-item"
            @click="deleteEvaluation(activity.evaluation._id)">
              <i class="fas fa-times" /> {{ $t('Remove') }}
            </button>
        </div>
      </div>

      <div>
        <span>{{ $t('Evaluation') }}</span>
        <strong v-if="activity.evaluation.scorecard && activity.evaluation.scorecard.name">{{ activity.evaluation.scorecard.name }}</strong>
        <span>na etapa</span>
        <strong v-if="activity.evaluation.stage_id">{{ activity.evaluation.stage_id.name }}</strong>
      </div>

      <div class="mt-2">
        <score-evaluation
          :value="activity.evaluation.score">
          </score-evaluation>
      </div>

      <div v-if="showAll" class="card mt-2">
        <div class="card-body">
          <div v-html="activity.evaluation.comment"></div>  
        </div>
        <div v-if="activity.evaluation.scorecard && activity.evaluation.scorecard.groups">
          <div 
            v-for="(group, group_index) in activity.evaluation.scorecard.groups"
            :key="group_index">
            <div class="card-header"><strong>{{ group.name }}</strong></div>
            
            <ul class="list-group list-group-flush">
              <li 
                class="list-group-item" 
                v-for="(question, question_index) in group.questions"
                :key="question_index">

                <div class="d-flex">
                  <div class="w-100 mr-3">
                    <strong>{{ question.name }}</strong>
                  </div>
                  <div class="w-100" style="max-width: 100px">
                    <score-evaluation :value="question.score"></score-evaluation>
                  </div>
                </div>

                <div
                  v-if="question.comment"
                  class="mt-3"
                  style="white-space: pre-wrap">{{ question.comment }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="mt-2">
        <a href="javascript:void(0)" @click="showAll=!showAll">{{ showAll ? $t('Show less') : $t('Show more') }}</a>
      </div>

      <div class="mt-2">
        <small>
          <span
            v-tooltip="$d(new Date(activity.created_at), 'long')">
            {{ $d(new Date(activity.created_at), 'short') }}
            </span>
          <span>
            por {{ author }} - 
            </span>
          <router-link
            class="link-discreet"
            :to="{path: '/job/' + activity.job._id }">
            {{ activity.job.title }}
            </router-link>
        </small>
      </div>

    </div>

    <div
      class="content"
      v-if="edit">
      <candidate-evaluation-form
        :initValue="edit"
        @updated="updatedEvaluation"
        @cancel="editCancel">
        </candidate-evaluation-form>  
    </div>

  </div>

</template>

<script>
import config from '@/config'
import CandidateEvaluationForm from '../Evaluation/CandidateEvaluationForm'
import ScoreEvaluation from '@/components/Parts/ScoreEvaluation'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'CandidateEvaluationItem',
  components: {
    CandidateEvaluationForm,
    ScoreEvaluation,
    Avatar
  },
  props: [
    'activity'
  ],
  data () {
    return {
      loading: false,
      showAll: false,
      edit: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    author () {
      return this.activity.author_user ? this.activity.author_user.name : (this.activity.evaluation.guest.name + ' (Convidado)')
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.activity.author_user.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    editEvaluation (data) {
      this.edit = data
    },
    editCancel () {
      this.edit = false
    },
    updatedEvaluation () {
      this.$store
      .dispatch('getActivities', {
        _id: this.activity._id
      })
      .then(() => {
        this.edit = false
      })
    },
    deleteEvaluation (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteEvaluation', id)
        .then((result) => {
          return this.$store.dispatch('deleteActivity', this.activity._id)
        })
        .then((result) => {
          this.loading = false
          this.$emit('deleted', result)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedEvaluationItem.vue